module.exports = __webpack_public_path__ + "img/student.5a91a10e.svg";